<template>
  <div class="padding">
    <v-card
      flat
      class="mx-auto"
      maxWidth="400"
      disabled
    >
      <v-card-title class="justify-center">
        <v-icon
          xLarge
        >
          {{ icon }}
        </v-icon>
      </v-card-title>
      <v-card-text class="subtitle-1 text-center">
        {{ label }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
};
</script>
<style lang="scss" scoped >
  .v-card--disabled {
    background-color: transparent;
  }
  .padding {
    padding-top: 4rem;
    padding-bottom: 5rem;
  }
</style>
